/* eslint-disable filename-rules/match */

import { ChakraProvider } from '@chakra-ui/react';
import { AppProps } from 'next/app';
import { useRouter } from 'next/router';

import { MainLayout } from '@r-client/admin/feature/layout';
import { theme } from '@r-client/admin/ui/theme';
import { GqlClientProvider } from '@r-client/shared/data/client';
import {
  createReportingConfig,
  ErrorReportingProvider,
  NavigationContextHandler,
  useReporting,
} from '@r-client/shared/data/error-reporting';
import { AuthProvider } from '@r-client/shared/feature/auth';
import { ConfigProvider } from '@r-client/shared/util/core';

import { getPublicConfig } from '../application.config';
import { useGqlManager } from '../gql-client';

const publicConfig = getPublicConfig();

const _reportingConfig = createReportingConfig({
  accessToken: publicConfig.rollbarClientToken,
  codeVersion: publicConfig.applicationVersion,
  environment: publicConfig.applicationEnvironment,
  serverHost: publicConfig.graphqlEndpointUrl,
  kind: 'rollbar',
});

function CustomApp({ Component, pageProps }: AppProps) {
  const gqlClient = useGqlManager(pageProps);
  const reporting = useReporting();
  return (
    <GqlClientProvider client={gqlClient} reporting={reporting}>
      <NavigationContextHandler useRouter={useRouter} />
      <ConfigProvider value={publicConfig}>
        <AuthProvider>
          <ChakraProvider theme={theme}>
            <MainLayout
              appLastUpdated={publicConfig.appLastUpdated}
              appReleaseVersion={publicConfig.appReleaseVersion}
            >
              <Component {...pageProps} />
            </MainLayout>
          </ChakraProvider>
        </AuthProvider>
      </ConfigProvider>
    </GqlClientProvider>
  );
}

function AppWithErrorReporting(props: AppProps) {
  return (
    <ErrorReportingProvider config={_reportingConfig}>
      <CustomApp {...props} />
    </ErrorReportingProvider>
  );
}

export default AppWithErrorReporting;
